import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import YoutubeEmbed from "../components/YoutubeEmbed";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";
import FormMini from "../components/forms/FormMini";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Tech Savvy Team Solutions - Elm Street</title>
        <meta
          name="description"
          content="When you are building a “business within a business”, Elm Street's flexible and scalable solutions are designed to support growing teams with one singular point of contact, one singular sign-on, and one singular partner."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/teams" />
        <meta property="og:title" content="Tech Savvy Team Solutions" />
        <meta
          property="og:description"
          content="When you are building a “business within a business”, Elm Street's flexible and scalable solutions are designed to support growing teams with one singular point of contact, one singular sign-on, and one singular partner."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <ExitModal>
        <div
          style={{
            backgroundImage: "url('orangebg.webp')",
            backgroundPosition: "center",
            backgroundSize: "fixed",
            padding: "30px",
            display: "block",
          }}
        >
                <div style={{textAlign:"center", paddingBottom:"20px"}}> <Typography variant="h3" component="h2" style={{ color: "#ffffff", textAlign: "center", paddingBottom:"10px" }}>Stay up to date...</Typography>
                <Typography variant="h5" component="h2" style={{ color: "#333666", textAlign: "center" }}>on the latest &amp; greatest in the industry.
                    Be the first to know about:</Typography>
                    <br />
                    <strong>+ Upcoming webinars with industry leaders<br />
                    + The latest in marketing &amp; lead gen strategies<br />
                    + Newly-published industry guides<br />
                    + First dibs on educational boot camps &amp; seminars<br /></strong>
                    </div>
                <div style={{backgroundColor:"#ffffff", padding:"25px"}}>
                  <FormMini buttonText="Register before you go" formName="es2_blog" listId="147953" utmOverride="exit_intent" />
                </div>
         </div>
     </ExitModal>

      <div
        style={{
          backgroundImage: "url('rsteambg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>tech-savvy</span>
                    <br />
                    team solutions
                  </Typography>
                  <p>Support and Build Your Dream Team.</p>
                  <Button variant="contained" color="secondary" href="#form">
                    schedule a demo
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div
          style={{
            marginTop: "75px",
            textAlign: "center",
          }}
        >
          <Grid container spacing={8}>
            <Grid item md={12} sm={12}>
              When you are building a “business within a business”, Elm Street's flexible and scalable solutions are
              designed to support growing teams with one singular point of contact, one singular sign-on, and one
              singular partner.
            </Grid>
          </Grid>
        </div>
      </Container>

      <div>
        <Container maxWidth="lg" style={{ paddingTop: "60px", paddingBottom: "85px" }}>
          <Grid container columnSpacing={8}>
            <Grid item md={4} sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h4" component="h4">
                the power of <br />
                <span style={{ color: "#f69c26" }}>one solution</span>
              </Typography>
              <br />
              <p>
                Avoid “tech fatigue” with Elm Street's advanced, all-in-one solutions. Imagine one partner to help you
                and your team's day-to-day flow smoothly.
              </p>
              <Button variant="contained" color="secondary" href="#form">
                take a tour today
              </Button>
            </Grid>

            <Grid item md={8} xs={12}>
              <YoutubeEmbed embedUrl="https://www.youtube.com/embed/F1jXTGc2Xng" />
            </Grid>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('teams2bg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  paddingTop: "50px",
                  paddingBottom: "50px",
                  height: "500px",
                }}
              >
                <div>
                  <Typography variant="h4" component="h4">
                    <span style={{ color: mainTheme.palette.secondary.main }}>
                      recruitment
                      <br />
                      &amp; retention
                    </span>{" "}
                    tools
                  </Typography>
                  <p>
                    With Elm Street's expansive portfolio of customizable solutions, we help growing teams “level up” in
                    order to be competitive and support happy agents.
                  </p>
                  <Button variant="contained" color="secondary" href="#form">
                    connect with us today
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "45px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/teams3.png"
                    width="1080px"
                    height="1066px"
                    alt="Elm Street For Teams - marketing technology for agents"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    marketing
                    <br />
                    technology
                  </span>
                  <br />
                  for agents
                </Typography>
                <br />
                <span>
                  Today's agents have high expectations when it comes to the tools, training and resources offered by
                  their brokerage. With Elm Street, busy teams have one partner delivering an intuitive CRM, lead
                  generation, IDX websites, social media marketing, automated communication workflows, top-of-mind
                  direct mail, team phone services, and more…all backed by fanatical support.
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ marginTop: "45px", marginBottom: "68px" }}>
        <div
          style={{
            paddingTop: "55px",
            paddingBottom: "55px",
            textAlign: "center",
          }}
        >
          <Typography variant="h4" component="h4">
            <span style={{ color: "#f69c26" }}>all-in-one solutions</span> to grow your team
          </Typography>
        </div>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/analytics_icon.svg" width="100px" height="100px" alt="Elm Street - Aadvanced CRM" />
            </div>
            <strong>
              ADVANCED
              <br />
              CRM
            </strong>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/check_icon.svg" width="100px" height="100px" alt="Elm Street - Intutive Dashboard" />
            </div>
            <strong>
              INTUITIVE
              <br />
              DASHBOARD
            </strong>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/responsive_icon.svg" width="100px" height="100px" alt="Elm Street - IDX Websites" />
            </div>
            <strong>
              IDX
              <br />
              WEBSITES
            </strong>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/social_icon.svg" width="100px" height="100px" alt="Elm Street - Social Media Marketing" />
            </div>
            <strong>
              SOCIAL MEDIA
              <br />
              MARKETING
            </strong>
          </Grid>
        </Grid>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/blog_icon.svg" width="100px" height="100px" alt="Elm Street - Automated Communication" />
            </div>
            <strong>
              AUTOMATED
              <br />
              COMMUNICATION
            </strong>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/email_icon.svg" width="100px" height="100px" alt="Elm Street - Direct Mail Newsletters" />
            </div>
            <strong>
              DIRECT MAIL
              <br />
              NEWSLETTERS
            </strong>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/mobile_icon.svg" width="100px" height="100px" alt="Elm Street - Telecommunication" />
            </div>
            <strong>
              TELECOM
              <br />
              SERVICES
            </strong>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/retention_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street - Recruitment &amp; Retention"
              />
            </div>
            <strong>
              RECRUITMENT
              <br />
              &amp; RETENTION
            </strong>
          </Grid>
        </Grid>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/support_icon.svg" width="100px" height="100px" alt="Elm Street - Fanatical Support" />
            </div>
            <strong>
              FANATICAL
              <br />
              SUPPORT
            </strong>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/training_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street - Training &amp; Education"
              />
            </div>
            <strong>
              TRAINING
              <br />
              &amp; EDUCATION
            </strong>
          </Grid>
          <Grid item md={3} sm={12}></Grid>
          <Grid item md={3} sm={12}></Grid>
        </Grid>

        <div
          style={{
            paddingTop: "30px",
            paddingBottom: "75px",
            textAlign: "center",
          }}
        >
          <Typography variant="h4" component="h4">
            <span style={{ color: "#f69c26" }}>are you ready</span> to streamline your business?
          </Typography>
          <p>Let Elm Street's Brokerage Success Team save you valuable time, money and resources.</p>
          <Button variant="contained" color="secondary" href="#form">
            schedule a demo
          </Button>
        </div>
      </Container>

      <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "45px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>easy</span>
                  <br />
                  onboarding
                </Typography>

                <p>
                  We make it easy to drive high technology adoption rates and get agents up and running with Elm
                  Street's solutions quickly and efficiently.
                </p>
                <Button variant="contained" color="secondary" href="#form">
                  learn more
                </Button>
              </Grid>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/teams4.png"
                    width="1080px"
                    height="1066px"
                    alt="Elm Street For Teams - Easy Onboarding"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "45px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/teams5.png"
                    width="1080px"
                    height="1066px"
                    alt="Elm Street For Teams - Training &amp; Fanatical Support"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    training <br />
                    &amp; fanatical
                  </span>
                  <br />
                  support
                </Typography>

                <p>
                  Technology is only as good as the people behind it. Busy brokerages need a reliable technology partner
                  that can deliver a smooth transition and continue to support and train incoming agents. Elm Street
                  offers both in-person and virtual training and support services designed to increase agent
                  productivity, all without the headache!
                </p>
                <Button variant="contained" color="secondary" href="#form">
                  take a tour
                </Button>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('brokerages5bg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  paddingTop: "50px",
                  paddingBottom: "50px",
                  height: "500px",
                }}
              >
                <div>
                  <Typography variant="h4" component="h4">
                    <span style={{ color: mainTheme.palette.secondary.main }}>custom</span>
                    <br />
                    services
                  </Typography>
                  <p>
                    Elm Street's 3sixtyfive.agency division offers a variety of brokerage growth and marketing services.
                    This elite team of marketing minds can help strategize, create, execute and analyze campaigns to
                    help busy brokerages grow.
                  </p>
                  <Button variant="contained" color="secondary" href="https://3sixtyfive.agency" target="_blank">
                    visit 3sixtyfive.agency
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              schedule a demo today
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>
                Connect with Elm Street's Brokerage Success Team today to explore your path to success.
              </strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      listId="147996"
                      formName="es2_teams"
                      successUrl="thankyou"
                      fieldList={["first_name", "last_name", "email", "phone", "roll"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
